// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container fluid grid-list-md>
    <v-row wrap>
      <v-col cols="12" justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'zones'"
        editRoute="zoneEdit"
        :filter="filters"
        :headers="headers"
        id="_id"
        name="Zone"
        permissions="zones"
        :searchBarText="searchBarText"
        pagination
        ></item-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

import {ENDPOINT} from '@/shared/constants'
import ItemList from '@sdgsystems/vue-common/components/ItemList.vue'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'Description',
          value: 'description',
          sortable: true
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'filters'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Zones.vue